import { render, staticRenderFns } from "./TermsForm.vue?vue&type=template&id=0ea4cd8a&scoped=true&"
import script from "./TermsForm.vue?vue&type=script&lang=ts&"
export * from "./TermsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea4cd8a",
  null
  
)

export default component.exports